<div *ngIf="router.url == '/blog'" class="blog-top">
  <div class="container top-title">
    <div class="title">Blog</div>
    <div class="b-title">
      <div class="slogan">Vize Başvuru Sürecinde Bilmeniz Gerekenler</div>
     
    </div>
  </div>
</div>
<div class="container">
  <div *ngIf="router.url != '/blog'" [ngClass]="{'top-title':count==0,'top-title-home':count>0}" class="row">
    <div class="section-title">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 0C6.72067 3.49437 9.5056 6.27934 13 6.5C9.5056 6.72067 6.72067 9.5056 6.5 13C6.27934 9.5056 3.49437 6.72067 0 6.5C3.49437 6.27934 6.27934 3.49437 6.5 0Z" fill="#0c9"></path></svg>
      <h3 class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">SEYAHATİNİZE Rehber</h3>
    </div>  
   
    <div class="b-title">
      <div class="slogan">Vize Başvuru Sürecinde Bilmeniz Gerekenler</div>
    <div *ngIf='count>0'  class="small-text">
      <a [routerLink]="['/blog']">Tüm Yazılar</a>
      <img _ngcontent-ng-c655296803="" src="../../../assets/images/arrow-right.svg" alt="">
          </div> 
    </div>
  </div>
<div class="row articles">
  <div class="row p0">
    <div class="col-md-4 p0" *ngFor="let blog of blogs">
      <div class="client-item item">
        <div class="img">
          <a [routerLink]="'/blog/'+ blog.pageUrl"> <app-img-view [imageUrl]="blog.imageUrl"></app-img-view></a>
        </div>
       <div class="client-body">
        <span class="client--content a-title"><h3>{{ blog.title }}</h3></span>
        <div class="client-btn">
         
          <a [routerLink]="'/blog/'+ blog.pageUrl">
            <img src="../../../assets/images/arrow-right.svg" alt="">
          </a>
        </div>
       </div>
        <!-- <div [innerHTML]="blog.content"></div> bu kısımda içerik çekilmektedir. -->
      </div>
    </div>
  </div>
</div>
</div>